export function shouldStopSectionListInfiniteScroll(
  filterKey: string | undefined,
  isLastSection: boolean,
  criteria?: { active: boolean; isLastFilteredSection: boolean },
): boolean {
  // Page-level filters (is_assigned / started_only) fetch everything up
  // front, so there is never a next page to load.
  if (filterKey) return true;
  // Active list criteria paginate over the server's filtered ordering and
  // carry their own end-of-list accounting.
  if (criteria?.active) return criteria.isLastFilteredSection;
  return isLastSection;
}
